const data = {
  'title': 'Rbitrage - Crypto Start Up',
  'content': 'In 2022 I worked with a small, cohesive team on Rbitrage, an early stage startup in the crypto space. This venture greatly developed my knowledge of cloud computing (AWS), cryptocurrencies and quantitative finance.',
  'github': '',
  'live': '',
  'technologies': [
    'AWS',
    'React',
    'Python',
    'GraphQL',
    'Cryptocurrency',
    'Nx'
  ],
}

export default data